// extracted by mini-css-extract-plugin
export default {"container":"OrgDetail_container__3sYes","banner":"OrgDetail_banner__3zX-F"};